import { useEffect, useRef } from "react";

export function useBoundedInfiniteScroll(input: {
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  onLoadMore?: () => void;
}) {
  const scrollRootRef = useRef<HTMLDivElement | null>(null);
  const sentinelRef = useRef<HTMLDivElement | null>(null);
  const requestPendingRef = useRef(false);

  useEffect(() => {
    if (!input.isFetchingNextPage) requestPendingRef.current = false;
  }, [input.isFetchingNextPage]);

  useEffect(() => {
    const root = scrollRootRef.current;
    const sentinel = sentinelRef.current;
    if (
      !root ||
      !sentinel ||
      !input.hasNextPage ||
      input.isFetchingNextPage ||
      !input.onLoadMore
    ) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0]?.isIntersecting || requestPendingRef.current) return;
        requestPendingRef.current = true;
        input.onLoadMore?.();
      },
      { root, rootMargin: "160px 0px" },
    );
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [input.hasNextPage, input.isFetchingNextPage, input.onLoadMore]);

  return { scrollRootRef, sentinelRef };
}
